"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("../Box"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["borderRadius", "boxShadow", "children", "classes", "className"];
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(() => {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden'
    }
  };
});
/**
 * **❗️ DEPRECATED**: Use the new `Card` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/data-display-card-card):
 *
 * ```tsx
 * import { Card } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/data-display-card-card)
 *
 * @deprecated
 */
const Card = /*#__PURE__*/_react.default.forwardRef(function Card(props, ref) {
  const {
      borderRadius = 'lg',
      boxShadow = 'sm',
      children,
      classes: classesOverrides,
      className
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/_react.default.createElement(_Box.default, (0, _extends2.default)({
    borderRadius: borderRadius,
    border: "sm",
    borderColor: "border.primary.opaque",
    boxShadow: boxShadow,
    bgColor: props.bgColor || 'background.primary.opaque',
    className: cx(classes.root, className),
    ref: ref
  }, other), children);
});
var _default = exports.default = Card;